import Vue from 'vue';
import {API_ROOT} from '../config'

export default Vue.resource(API_ROOT + 'order{/id}', {});



// WEBPACK FOOTER //
// ./client/resources/orderResource.js